import React, { useContext } from 'react';

import OnboardingCoachNotificationsContext from '../../context/OnboardingCoachNotificationsContext';

import { StyledAlert } from './styles';
import texts from './texts';

const OnboardingChecklistAlert = () => {
  const { setShowModal } = useContext(OnboardingCoachNotificationsContext);

  return (
    <StyledAlert severity="warning" onClick={() => setShowModal(true)}>
      {texts.title}
    </StyledAlert>
  );
};

export default OnboardingChecklistAlert;
